import {
	allows,
	PermissionMatrixName,
} from '@netx/core-permissions/utils/allows';
import {type IAsset} from '../schema';

export const canDeleteAsset = (asset?: Pick<IAsset, 'permissionMatrix'>) =>
	asset != null && allows(asset.permissionMatrix, PermissionMatrixName.DELETE);

export default canDeleteAsset;
